import { JsonViewProps } from "../types/common";
import { BASE_16_CLOUDSCAPE_THEME } from "../constants";

export function useReactJsonProps(
  customProps?: Partial<JsonViewProps>
): JsonViewProps {
  const defaultProps = {
    displayDataTypes: false,
    displayObjectSize: false,
    quotesOnKeys: false,
    displayArrayKey: false,
    theme: BASE_16_CLOUDSCAPE_THEME,
  } as const;

  return {
    ...defaultProps,
    ...customProps,
  };
}
